<template>
  <div class="login-wrap">
    <div class="lb-login">
      <img src="../../assets/img/login_text.png" alt="">
    </div>
    <div class="login-box">
      <img class="login-left"  src="../../assets/img/sleep_bg.png" alt="" />
      <div class="box-right">
        <!-- 扫描登录 -->
        <!-- <img v-if="loginType == 'accNumber'" @click="goCode" class="loginEwm" src="../../assets/img/login-ewm.png"
          alt="" />
        <img v-if="loginType == 'ewmCode'" @click="goAccNum" class="loginPc" src="../../assets/img/login-pc.png"
          alt="" /> -->
        <div class="ms-title">账号登录</div>
        <el-form v-if="loginType == 'accNumber'" :model="param" :rules="rules" ref="login" label-width="0px"
          class="ms-content">
          <el-form-item prop="userTel">
            <el-input class="inputStyle" v-model="param.userTel" placeholder="请输入账号">
              <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input class="inputStyle" type="password" placeholder="请输入密码" v-model="param.password"
              @keyup.enter.native="submitForm()">
              <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
            </el-input>
          </el-form-item>
          <!-- 验证码 -->
          <!-- <el-form-item prop="verifyCode" id="verifyCode">
            <el-input class="inputStyle" v-model="param.verifyCode" placeholder="验证码" style="width: 270px">
              <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
            </el-input>
          </el-form-item> -->
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('param')">登录</el-button>
          </div>
          <div class="remPsw">
            <el-checkbox v-model="param.rememberMe"></el-checkbox>
            <div class="rememberPsw">记住密码</div>
          </div>
        </el-form>
        <div v-if="loginType == 'ewmCode'">
          <div class="codeStyle">
            <vue-qr :text="qrText" :size="1000"></vue-qr>
          </div>
          <div class="codeText">使用智谷APP扫码登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr';
import { getToken, denglu } from '../../api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
// import { encrypt,responseDataGet } from '../../../public/common_encrypt';
// import axios from 'axios';
// import Qs from 'qs'

export default {
  components: {
    VueQr,
  },
  data: function () {
    return {
      resultFlag: null,
      loginType: 'accNumber',
      pollInterval: null,
      qrText: '',
      tokenStr: '',
      param: {
        userTel: '',
        password: '',
        // verifyCode: '',
        rememberMe: false,
      },
      rules: {
        userTel: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        // verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    };
  },

  mounted() {
    this.loadUserInfo();
    this.verifyCode = this.getGVerify('verifyCode');
    this.getCodeImg();
  },
  methods: {
    // 记住密码
    loadUserInfo() {
      if (localStorage.getItem('userSchoolInfo')) {
        const userSchoolInfo = localStorage.getItem('userSchoolInfo');
        const { userTel, password, rememberMe } = JSON.parse(userSchoolInfo);
        if (rememberMe) {
          this.param.userTel = userTel;
          this.param.password = password;
          this.param.rememberMe = rememberMe;
        } else {
          this.param = {
            userTel: '',
            password: '',
            verifyCode: '',
            rememberMe: false,
          };
        }
      }
    },
    goCode() {
      this.loginType = 'ewmCode';
      this.getCodeImg();
      // 开始轮询扫码状态
      this.getLoginCode();
      this.pollInterval = setInterval(() => {
        if (this.resultFlag == '-1') {
          this.getLoginCode();
        }
      }, 2000);
    },
    goAccNum() {
      this.loginType = 'accNumber';
      clearInterval(this.pollInterval);
      this.$router.go(0);
      // this.verifyCode = this.getGVerify('verifyCode');
    },
    getGVerify(id) {
      function GVerify(options) {
        //创建一个图形验证码对象，接收options对象为参数
        this.options = {
          //默认options参数值
          id: 'verifyCode', //容器Id
          canvasId: 'verifyCanvas', //canvas的ID
          width: '102', //默认canvas宽度
          height: '50', //默认canvas高度
          type: 'blend', //图形验证码默认类型blend:数字字母混合类型、number:纯数字、letter:纯字母
          code: '',
        };

        if (Object.prototype.toString.call(options) == '[object Object]') {
          //判断传入参数类型
          for (var i in options) {
            //根据传入的参数，修改默认参数值
            this.options[i] = options[i];
          }
        } else {
          this.options.id = options;
        }

        this.options.numArr = '0,1,2,3,4,5,6,7,8,9'.split(',');
        this.options.letterArr = getAllLetter();

        this._init();
        this.refresh();
      }

      GVerify.prototype = {
        /**版本号**/
        version: '1.0.0',

        /**初始化方法**/
        _init: function () {
          var con = document.getElementById(this.options.id);
          var canvas = document.createElement('canvas');
          /*this.options.width = con.offsetWidth > 0 ? con.offsetWidth : "100";
                            this.options.height = con.offsetHeight > 0 ? con.offsetHeight : "30";*/
          canvas.id = this.options.canvasId;
          canvas.width = this.options.width;
          canvas.height = this.options.height;
          canvas.style.cursor = 'pointer';
          canvas.style.position = 'absolute';
          //   canvas.style.top = '65%';
          //   canvas.style.left = '62%';
          canvas.style.top = '59.1%';
          canvas.style.left = '68%';
          canvas.style.borderRadius = '6px';
          canvas.innerHTML = '您的浏览器版本不支持canvas';
          con.appendChild(canvas);
          var parent = this;
          canvas.onclick = function () {
            parent.refresh();
          };
        },

        /**生成验证码**/
        refresh: function () {
          this.options.code = '';
          var canvas = document.getElementById(this.options.canvasId);
          if (canvas.getContext) {
            var ctx = canvas.getContext('2d');
          }
          ctx.textBaseline = 'middle';

          ctx.fillStyle = randomColor(180, 240);
          ctx.fillStyle = 'display:inline';
          ctx.fillRect(0, 0, this.options.width, this.options.height);

          if (this.options.type == 'blend') {
            //判断验证码类型
            var txtArr = this.options.numArr.concat(this.options.letterArr);
          } else if (this.options.type == 'number') {
            var txtArr = this.options.numArr;
          } else {
            var txtArr = this.options.letterArr;
          }

          for (var i = 1; i <= 4; i++) {
            var txt = txtArr[randomNum(0, txtArr.length)];
            this.options.code += txt;
            ctx.font = '20px SimHei';
            //ctx.font = randomNum(this.options.height/2, this.options.height) + 'px SimHei'; //随机生成字体大小
            ctx.fillStyle = randomColor(50, 160); //随机生成字体颜色
            /* ctx.shadowOffsetX = randomNum(-3, 3);
                                  ctx.shadowOffsetY = randomNum(-3, 3);*/
            ctx.shadowBlur = randomNum(-3, 3);
            ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
            var x = (this.options.width / 5) * i;
            var y = this.options.height / 2;
            var deg = randomNum(-30, 30);
            /**设置旋转角度和坐标原点**/
            ctx.translate(x, y);
            ctx.rotate((deg * Math.PI) / 180);
            ctx.fillText(txt, 0, 0);
            /**恢复旋转角度和坐标原点**/
            ctx.rotate((-deg * Math.PI) / 180);
            ctx.translate(-x, -y);
          }
          /**绘制干扰线**/
          for (var i = 0; i < 4; i++) {
            ctx.strokeStyle = randomColor(40, 180);
            ctx.beginPath();
            ctx.moveTo(randomNum(0, this.options.width / 2), randomNum(0, this.options.height / 2));
            ctx.lineTo(randomNum(0, this.options.width / 2), randomNum(0, this.options.height));
            ctx.stroke();
          }
          /**绘制干扰点**/
          for (var i = 0; i < this.options.width / 4; i++) {
            ctx.fillStyle = randomColor(0, 255);
            ctx.beginPath();
            ctx.arc(randomNum(0, this.options.width), randomNum(0, this.options.height), 1, 0, 2 * Math.PI);
            ctx.fill();
          }
        },

        /**验证验证码**/
        validate: function (code) {
          var verifyCode = code.toLowerCase();
          var v_code = this.options.code.toLowerCase();
          if (verifyCode == v_code) {
            return true;
          } else {
            return false;
          }
        },
      };

      /**生成字母数组**/
      function getAllLetter() {
        var letterStr = 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z';
        return letterStr.split(',');
      }
      /**生成一个随机数**/
      function randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      }
      /**生成一个随机色**/
      function randomColor(min, max) {
        var r = randomNum(min, max);
        var g = randomNum(min, max);
        var b = randomNum(min, max);
        return 'rgb(' + r + ',' + g + ',' + b + ')';
      }

      return new GVerify(id);
    },
    // submitForm() {
    //   this.$refs.login.validate(() => {
    //     var info = {
    //       loginType: 2,
    //       userTel: this.param.userTel,
    //       password: this.param.password,
    //       token: this.tokenStr,
    //     };
    //     console.log('info', info);
    //     var data = encrypt(JSON.stringify(info));
    //     console.log('data', data);
    //     invokeFrontUser(data).then((res) => {
    //       console.log('33445566', res);
    //       var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
    //       console.log('denglu数据', ress);
    //       if (res.result == '1') {
    //         this.$message.success('登录成功');
    //         localStorage.setItem('ms_username', ress.nickName);
    //         localStorage.setItem('token', ress.accessId);
    //         localStorage.setItem('userId', ress.userId);
    //         localStorage.setItem('groupName', ress.groupName || '');
    //         localStorage.setItem('schoolName', ress.schoolName || '');
    //         localStorage.setItem('menu_id', '9');
    //         localStorage.setItem('userSchoolInfo', JSON.stringify(this.param));
    //         this.$router.push('/workbench'); //跳转工作台
    //       } else {
    //         this.$message.error(res.msg);
    //       }
    //     });
    //   });
    // },
    submitForm() {
      this.$refs.login.validate(() => {
        // if (this.verifyCode.validate(this.param.verifyCode)) {
        // } else {
        //   this.$message.error('验证码输入错误');
        //   return false
        // }
        var data = {
          cellphoneNumber: this.param.userTel,
          // userAccount: this.param.userTel,
          password: this.param.password
        }
        console.log(data)
        denglu(data).then(res => {
          console.log(res);
          if (res.result == 1) {
            this.$message.success('登录成功');
            localStorage.setItem('ms_username', res.data.username);
            localStorage.setItem('token', res.data.accessId);
            localStorage.setItem('userId', res.data.id);
            localStorage.setItem('menu_id', '0');
            this.$router.push('/workbench');//跳转工作台
          } else {
            this.$message.error(res.info);
          }
        });
      });
    },
    getCodeImg() {
      getToken().then((res) => {
        var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
        this.qrText = JSON.stringify(ress);
        console.log('2233', this.qrText);
        this.tokenStr = ress.commonId;
      });
    },
    getLoginCode() {
      var info = {
        loginType: 1,
        token: this.tokenStr,
      };
      console.log('info', info);
      var data = encrypt(JSON.stringify(info));
      console.log('data', data);
      invokeFrontUser(data).then((res) => {
        console.log('33445566', res);
        this.resultFlag = res.result;
        if (res.data) {
          var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
          console.log('denglu数据', ress);
          if (res.result == '1') {
            this.$message.success('登录成功');
            localStorage.setItem('ms_username', ress.nickName);
            localStorage.setItem('token', ress.accessId);
            localStorage.setItem('userId', ress.userId);
            localStorage.setItem('menu_id', '9');
            this.$router.push('/workbench'); //跳转工作台
            clearInterval(this.pollInterval);
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #5F4E42;
  border-color: #5F4E42;
}

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  /* background-image: url(../../assets/img/Logo-title.png); */
  background-image: url(../../assets/img/login_bg.png);
  background-size: 100% 100%;

  .lb-login {
    position: absolute;
    left: 46px;
    top: 43px;
    width: 304px;
  }
}

.login-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.box-right {
  position: relative;
  width: 500px;
  height: 500px;
  // background: #fff;
  padding: 80px 0 58px;
  border-radius: 0px 10px 10px 0px;
}

.loginEwm {
  position: absolute;
  width: 43px;
  height: 47px;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.loginPc {
  position: absolute;
  width: 43px;
  height: 40px;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.inputStyle {
  width: 383px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #dddddd;
}

/deep/ .el-input--small .el-input__inner {
  height: 50px;
  line-height: 50px;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 24px;
}

/deep/ .el-button--small {
  font-weight: 500;
  font-size: 22px;
}

.verifyCode {
  display: flex;
  align-items: center;
  width: 384px;
  height: 50px;
  margin-bottom: 48px;
  //   line-height: 50px;
  background: #fceaea;
  border-radius: 4px;
  border: 1px solid rgba(232, 51, 51, 0.1);
}

.loginYz {
  width: 20px;
  height: 24px;
  margin-left: 19px;
}

.loginText {
  font-weight: 500;
  font-size: 16px;
  color: #676767;
  margin-left: 21px;
}

.remPsw {
  margin-top: 16px;
  display: flex;
}

.rememberPsw {
  font-weight: 400;
  font-size: 16px;
  color: #9d9d9d;
  margin-left: 4px;
}

.ms-title {
  //   width: 100%;
  //   line-height: 50px;
  text-align: center;
  //   font-size: 20px;
  //   color: #000;

  font-weight: 500;
  font-size: 24px;
  color: #474747;
  //   border-bottom: 1px solid #ddd;
}

.codeStyle {
  width: 200px;
  height: 200px;
  border-radius: 6px;
  border: 2px solid #fceaea;
  padding: 25px;
  margin: 32px 150px 24px;
}

.ewmCode {
  width: 151px;
  height: 151px;
}

.codeText {
  font-weight: 500;
  font-size: 16px;
  color: #9d9d9d;
  text-align: center;
}

.ms-login {
  /* display: flex; */
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;

  overflow: hidden;
}

.login-left {
  width: 400px;
  height: 400px;
}

.ms-content01 {
  background: rgba(255, 255, 255, 0.3);
}

.ms-content {
  padding: 30px 58px;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  //   width: 100%;
  //   height: 36px;
  //   margin-bottom: 10px;
  width: 384px;
  height: 50px;
  background: linear-gradient(270deg, #5F4E42  0%, #5F4E42  100%);
  border-radius: 4px;
}

/deep/ .el-button--primary {
  border-color: white;
}

.ms-title01 {
  margin-bottom: 50px;
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>
